import React from "react";

import CompanyList from "../../components/DivisionsList/DivisionList";
import Splitter from "../../components/ui/Splitter/Splitter";
import NewDivisionForm from "../../forms/NewDivisionForm/NewDivisionForm";

export const Divisions = () => (
  <Splitter left={<CompanyList />} right={<NewDivisionForm />} />
);
